export const ENVIRONMENT_QUERY_PARAM = 'env';
